import { render, staticRenderFns } from "./value-validate.vue?vue&type=template&id=47b469a0"
import script from "./value-validate.vue?vue&type=script&lang=js"
export * from "./value-validate.vue?vue&type=script&lang=js"
import style0 from "./value-validate.vue?vue&type=style&index=0&id=47b469a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports